module.exports = __webpack_public_path__ + "static/media/sql.2a6fe6f6.png";